import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";

export class NoneCalculator extends CalculatorBase{


    InternalInstanceUpdated(previousInstance: HTMLDivElement) {
    }

    ExecuteCalculation():{RegularPrice:any,SalePrice:any,Quantity:number}  {
        return {RegularPrice: '',SalePrice: '',Quantity:this.GetQuantityInput()};
    }


}